import ImageApp from "@/components/ui/image-app";
import { EActionMethod, IItemPayment } from "@/utilities/types/Payment";
import { Button } from "rizzui";
import { CiImageOff } from "react-icons/ci";
import { isEmpty } from "lodash";
import { IoMdClose } from "react-icons/io";

type IPropsCheckPayment = {
  onClose: () => void;
  openModalReject: () => void;
  openModalApproved: () => void;
  item: IItemPayment;
};

export default function CheckPayment(props: IPropsCheckPayment) {
  const { openModalReject, openModalApproved, item, onClose } = props;
  const url = item.asset?.urls.at(0)?.url|| "";

  return (
    <div className="w-full p-6">
      <div className="flex flex-row justify-end">
        <IoMdClose size={24} onClick={onClose}/>
      </div>

      {/* image of screenshot payment */}
      <div>
        {!isEmpty(url) ? (
          <ImageApp
            src={item.asset?.urls.at(0)?.url}
            alt="screenshot-payment"
          />
        ) : (
          <CiImageOff className="w-full h-full" />
        )}
      </div>

      <div className="flex flex-row justify-around items gap-2 mt-4">
        <Button size="sm" onClick={openModalApproved}>
          {EActionMethod.APPROVED}
        </Button>
        <Button
          variant="outline"
          color="danger"
          size="sm"
          onClick={openModalReject}
        >
          {EActionMethod.REJECTED}
        </Button>
      </div>
    </div>
  );
}
